<button
  class="dataset-header-dropdown-trigger"
  [matMenuTriggerFor]="menu"
  aria-label="Dataset actions menu"
  [disabled]="isDisabled"
  data-test="dataset-context-menu"
>
  <capra-icon class="dropdown-icon" icon="icon-caret-down"></capra-icon>
</button>
<mat-menu class="menu dataset-header-menu-panel" #menu="matMenu">
  <mode-dropdown-context-menu
    [isDirty]="isDirty"
    [datasetToken]="datasetToken"
    [datasetShareLink]="datasetShareLink"
    [isPersonal]="isPersonal"
    [showGoToDataWorkspace]="showGoToDataWorkspace"
    [thoughtspotDataWorkspaceLink]="thoughtspotDataWorkspaceLink"
    [modeStudioEnabled]="modeStudioEnabled"
    [canSaveCodeChanges]="(isSheetDataset$ | async) === false"
    [canSyncToGithub]="(canSyncToGithub$ | async) ?? false"
    [githubLink]="(getGithubLink$ | async) ?? ''"
    [publishOption]="publishOption"
    (handleSave)="handleSave()"
    (viewOrPreviewDataset)="viewOrPreviewDataset()"
    (handleUseInNewReport)="handleUseInNewReport()"
    (handleGithubSync)="handleGithubSync()"
    (publishOptionClicked)="publishOptionClicked.emit($event)"
  >
    <button mat-menu-item move-space>
      <ng-content select="[move-space]"></ng-content>
    </button>
    <button mat-menu-item rename-report>
      <ng-content select="[rename-report]"></ng-content>
    </button>
    <button mat-menu-item manage-schedule data-test="active-schedule-button">
      <ng-content select="[manage-schedule]"></ng-content>
    </button>
  </mode-dropdown-context-menu>
</mat-menu>
